// @flow
import * as React from 'react';
import { Breadcrumbs, Container, Divider, Link as MuiLink, Stack, Typography } from '@mui/material';
import { AgentForm } from '../../features';
import { useAgentByContextSuspenseQuery } from '../../shared';
import { Suspense } from 'react';
import { Preloader } from '@coverright/features';
import { Link } from 'react-router-dom';
import { getRoute } from '../../app/router';

export const Profile = () => {


  return (
    <Container maxWidth={'sm'} sx={{mt: 2}}>
      <Breadcrumbs aria-label="breadcrumb">
        <MuiLink component={Link}
                 underline="hover" color="inherit"
                 to={`/${getRoute('profile')}`}>
          Settings
        </MuiLink>
        <Typography>My profile</Typography>
      </Breadcrumbs>

      <Divider sx={{mb: 2, mt: 1}} />

      <Stack gap={3}>
        <Typography variant="subtitle1">My profile</Typography>

        <Suspense fallback={<Preloader sx={{minHeight: 300}} />}>
          <Form />
        </Suspense>
      </Stack>
    </Container>
  );
};

const Form = () => {
  const {data} = useAgentByContextSuspenseQuery();

  return <AgentForm input={data.agentByContext}
                    hideCancelButton
                    onSubmit={() => {}} />
}
